export const getInitialState = (): any => ({
  previewsMergeData: {},
  previewsMergeStatus: 0
});
